<opac-user-section>
  <div class="header-authors" slot="header">
    <div class="header">
      <h2 (click)="viewAll()">{{ 'user.lists.authors' | translate }}</h2>
      <div class="header-actions">
        <opac-button class="hide-mobile" type="secondary" (click)="viewAll()">
          {{ 'common.viewMore' | translate }}
        </opac-button>
        <opac-button
          class="hide-tablet"
          (click)="viewAll()"
          [ariaLabel]="'common.viewMore' | translate"
          [opacTooltip]="'common.viewMore' | translate">
          <opac-icon icon="navigate_next" slot="only-icon"></opac-icon>
        </opac-button>

        <opac-button
          [opac-menu-trigger]="sliderAuthorsActionsMenu"
          [ariaLabel]="'lists.moreActions' | translate"
          [opacTooltip]="'lists.moreActions' | translate">
          <opac-icon icon="more_vertical" slot="only-icon"></opac-icon>
        </opac-button>
      </div>
    </div>

    <span class="header-subtitle">
      {{ authors?.length }} {{ (authors?.length === 1 ? 'common.item' : 'common.items') | translate }}
    </span>
  </div>

  <opac-menu #sliderAuthorsActionsMenu>
    <opac-menu-item (selected)="addAuthors()">
      <opac-icon icon="add"></opac-icon>
      {{ 'lists.addAuthors' | translate }}
    </opac-menu-item>

    <opac-menu-item *ngIf="authors?.length > 0" (selected)="showUnfollowedAuthorsDialog.set(true)">
      <opac-icon icon="delete"></opac-icon>
      {{ 'common.deleteAll' | translate }}
    </opac-menu-item>
  </opac-menu>

  <opac-swiper [configuration]="swiperConfig">
    <opac-swiper-item *ngFor="let author of authors; let i = index" class="author-slider">
      <opac-author-card-item
        [name]="author.author"
        [backgroundColor]="author.color"
        [backgroundVectorImageIndex]="i"></opac-author-card-item>
    </opac-swiper-item>
  </opac-swiper>

  <opac-no-results-cta *ngIf="authors.length === 0">
    {{ 'user.list.authors.follow' | translate }}
    <opac-button type="secondary" (click)="addAuthors()"> {{ 'user.list.authors.add' | translate}} </opac-button>
  </opac-no-results-cta>
</opac-user-section>

<div class="wrapper" *ngIf="placeholder">
  <div class="slider-component">
    <div class="slider-component__title">
      <h2>&nbsp;</h2>
    </div>

    <opac-swiper [configuration]="swiperPlaceholderConfig">
      <opac-swiper-item *ngFor="let item of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]">
        <div class="placeholder-cover">
          <div class="item__img">
            <img src="/assets/cover_white_215.png" />
          </div>
        </div>
      </opac-swiper-item>
    </opac-swiper>
  </div>
</div>

<opac-confirmation-dialog
  [acceptLabel]="'common.confirm'"
  [cancelLabel]="'common.cancel'"
  [open]="showUnfollowedAuthorsDialog()"
  [title]="'lists.unfollowAll' | translate"
  (accept)="unfollowAllAuthors()"
  (cancel)="showUnfollowedAuthorsDialog.set(false)">
  <p>{{ 'lists.unfollowAllAuthors' | translate }}</p>
</opac-confirmation-dialog>
